<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">信息标签（注册）</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>类型：</label>
          <el-select v-model="type" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editTagDialog(-1)">新建标签</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="createTime" label="时间" v-if="checkColList.indexOf('时间') > -1" ></el-table-column>
          <el-table-column property="" label="性别" v-if="checkColList.indexOf('性别') > -1">
            <template #default="scope">
              {{scope.row.sex == 0?'通用':scope.row.sex == 1?'男':scope.row.sex == 2?'女':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="类型" v-if="checkColList.indexOf('类型') > -1">
            <template #default="scope">
              {{scope.row.type == 0?'通用':scope.row.type == 1?'关于我':scope.row.type == 2?'理想的TA':''}}
            </template>
          </el-table-column>
          <el-table-column property="tag" label="信息标签" v-if="checkColList.indexOf('信息标签') > -1"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              {{scope.row.state == 0?'待启用':scope.row.state == 1?'已启用':scope.row.state == 2?'已停用':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editTagDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-show="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.$index, scope.row, 1)">启用</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="warning" v-show="scope.row.state == 1" @click="updateState(scope.$index, scope.row, 2)">停用</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getSysTagPageList, updateSysTagState } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import TagManageDialog from "./components/TagManageDialog";

export default {
  name: "SysTag",
  components: {  },
  data() {
    return {

      sexArray: [
        {label: '不限', value: -1},
        {label: '通用', value: 0},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,

      typeArray: [
        {label: '不限', value: -1},
        {label: '通用', value: 0},
        {label: '关于我', value: 1},
        {label: '理想的TA', value: 2},
      ],
      type: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待启用', value: 0},
        {label: '已启用', value: 1},
        {label: '已停用', value: 2},
      ],
      state: -1,

      //刷新组
      colList: ['时间', '性别', '类型', '信息标签', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.sex = -1;
      this.type = -1;
      this.state = -1;
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['type'] = this.type;
      param['state'] = this.state;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSysTagPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editTagDialog(idx, row) {
      let _title = '';
      let tagForm = {}
      if (idx > -1) {
        _title = '编辑标签'
        tagForm = Object.assign({}, row);
      }else {
        _title = '新建标签'
      }
      Dialog.open({
        title: _title,
        component: TagManageDialog,
        data: {
          tagForm: tagForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateSysTagState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
